import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Spin } from 'antd';

import { RootState } from '../../../../store';
import { MakeClearData, SelectedNewChatItemEvent, UnreadCountData } from '../../models';
import ChatMessagesHeader from './chat-messages-header';
import MessageList from './message-list';
import MessageTextArea from './message-text-area';

import './styles.less';

export type ChatMessagesAreaProps = {
  setNewUnreadCount: React.Dispatch<React.SetStateAction<UnreadCountData | undefined>>;
  selectedNewChatItem: SelectedNewChatItemEvent;
  updateMessageControl: () => void;
};

const ChatMessagesArea = ({ setNewUnreadCount, selectedNewChatItem, updateMessageControl }: ChatMessagesAreaProps) => {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [messageSearchValue, setMessageSearchValue] = useState<string>();
  const [makeClearData, setMakeClearData] = useState<MakeClearData>({ clear: true });

  const selectedChatItem = useSelector((state: RootState) => state.smses.selectedChatItem);

  useEffect(() => {
    clearData();
  }, [makeClearData]);

  const clearData = () => {
    setPageNumber(1);
    setMessageSearchValue(undefined);
  };

  return (
    <>
      <ChatMessagesHeader
        messageSearchValue={messageSearchValue}
        setMessageSearchValue={setMessageSearchValue}
        setPageNumber={setPageNumber}
        updateMessageControl={updateMessageControl}
      />

      <MessageList
        setNewUnreadCount={setNewUnreadCount}
        selectedNewChatItem={selectedNewChatItem}
        messageSearchValue={messageSearchValue}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        makeClearData={makeClearData}
        setMakeClearData={setMakeClearData}
      />

      <Spin spinning={selectedChatItem?.optedOut === true} tip="The client has opted out of receiving SMS communications" size="small">
        <MessageTextArea makeClearData={makeClearData} disabled={selectedChatItem?.optedOut === true} />
      </Spin>
    </>
  );
};

export default ChatMessagesArea;
